import { FaClipboardList } from "react-icons/fa";
import ServiceRow from "./ServiceRow";
import { FaStethoscope, FaUserMd, FaHospitalAlt } from "react-icons/fa";
import './SistematskiPregledi.css'
export default function SistematskiPregledi() {
  return (
    <ServiceRow
      id='sistematki'
      icon={<FaClipboardList />}
      title="Систематски прегледи – законска обврска за работодавачите"
    >
      <p className="intro-text">
        Согласно важечката законска регулатива, работодавачот е должен да обезбеди
        систематски и периодични здравствени прегледи за своите вработени.
      </p>

      <div className="mini-card full-width">
        <h4>🎯 Цел на прегледите</h4>
        <ul className="service-list">
          <li><span className="check">✓</span> Заштита на здравјето на вработените</li>
          <li><span className="check">✓</span> Превенција на професионални заболувања</li>
          <li><span className="check">✓</span> Проценка на работната способност</li>
        </ul>
      </div>

      {/* PACKAGES GRID */}
      {/* 📦 PACKAGES */}
      <div className="system-packages-grid">

        <div className="system-package-card">
          <h5>
            <FaStethoscope className="system-icon" />
            Основен пакет
          </h5>

          <ul className="service-list">
            <li><span className="check">✓</span> Општ лекарски преглед</li>
            <li><span className="check">✓</span> Крвен притисок</li>
            <li><span className="check">✓</span> BMI индекс</li>
            <li><span className="check">✓</span> Лабораторија (крв и урина)</li>
            <li><span className="check">✓</span> ЕКГ</li>
          </ul>
        </div>

        <div className="system-package-card">
          <h5>
            <FaUserMd className="system-icon" />
            Среден пакет
          </h5>

          <ul className="service-list">
            <li><span className="check">✓</span> Сè од основниот пакет</li>
            <li><span className="check">✓</span> Проверка на вид и слух</li>
            <li><span className="check">✓</span> Шеќер и масти во крв</li>
            <li><span className="check">✓</span> ЕКГ</li>
          </ul>
        </div>

        <div className="system-package-card">
          <h5>
            <FaHospitalAlt className="system-icon" />
            Напреден пакет
          </h5>

          <ul className="service-list">
            <li><span className="check">✓</span> Сè од средниот пакет</li>
            <li><span className="check">✓</span> Ултразвук на абдомен</li>
            <li><span className="check">✓</span> Спирометрија</li>
            <li><span className="check">✓</span> Проширени анализи</li>
            <li><span className="check">✓</span> Специјалистички прегледи</li>
          </ul>
        </div>

      </div>

      {/* CORPORATE SECTION */}
      <div className="bottom-box">
        <h4>🏢 Корпоративни решенија</h4>
        <ul className="service-list">
          <li><span className="check">✓</span> Организација на прегледи во краток рок</li>
          <li><span className="check">✓</span> On-site прегледи во компанија</li>
          <li><span className="check">✓</span> Флексибилни термини</li>
          <li><span className="check">✓</span> Индивидуални извештаи + анализа</li>
        </ul>
      </div>

      {/* WARNING BOX */}
      <div className="mini-card full-width">
        <h4>📌 Важно</h4>
        <p className="intro-text">
          Неспроведувањето на систематски прегледи може да резултира со санкции
          за работодавачот и зголемен ризик за здравјето на вработените.
        </p>
      </div>

      
    </ServiceRow>
  );
}